export default "__VITE_ASSET__BefwplI5__"